import React from 'react';
import { Controller } from 'react-hook-form';
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import FormLabel from '@mui/material/FormLabel';
import FormHelperText from '@mui/material/FormHelperText';
import { RadioContainer } from '#component/project/form/project/styles';
import { convertTemperature, convertTemperatureToString, convertTemperatureUnit } from '#helper';

const getLabel = (minT, maxT, measurementSystem) => {
  if (maxT === minT) {
    return convertTemperatureToString(minT, measurementSystem);
  }
  return `${convertTemperature(minT, measurementSystem)} - ${convertTemperature(maxT, measurementSystem)}${convertTemperatureUnit(measurementSystem)}`;
};

const RHFRadioGroup = ({
  name,
  control,
  data,
  label,
  disabled,
  account,
  isTemperature,
  rules,
  ...rest
}) => (
  <Controller
    name={name}
    control={control}
    rules={rules}
    render={({ field, fieldState: { error, isTouched } }) => (
      <RadioContainer
        component="fieldset"
        disabled={disabled}
      >
        <FormLabel component="legend">{label}</FormLabel>
        <RadioGroup {...field} {...rest} row>
          {data.items.map(item => (
            <FormControlLabel
              key={item.id}
              value={item.value}
              control={<Radio />}
              label={
                isTemperature ?
                  getLabel(item.minT, item.maxT, account && account.measurementSystem) :
                  item.label
              }
            />
          ))}
        </RadioGroup>
        {(isTouched || !!error) && error && <FormHelperText error>{error.message}</FormHelperText>}
      </RadioContainer>
    )}
  />
);

export default RHFRadioGroup;
